export type LocaleProperties = {
  locale: string
  localeCountry: string
  storefrontLocale: string
  storefrontLocaleCountry: string
  cfCountry: string | null
  isMismatchedCountry: boolean | null
}

const countryOf = (locale: string) => (locale.split('-')[1] || '').toUpperCase()

/**
 * `locale` deliberately carries the Content Locale, so it keeps the seven values
 * every dashboard is built on while the URL space grows (ADR-0006). The URL is
 * reported separately as `storefrontLocale`. Do not "correct" this.
 */
export function buildLocaleProperties(
  storefrontLocale: string,
  contentLocale: string,
  geoCountry?: string | null
): LocaleProperties {
  const storefrontLocaleCountry = countryOf(storefrontLocale)
  const cfCountry = geoCountry || null

  return {
    locale: contentLocale,
    localeCountry: countryOf(contentLocale),
    storefrontLocale,
    storefrontLocaleCountry,
    cfCountry,
    isMismatchedCountry: cfCountry ? cfCountry !== storefrontLocaleCountry : null,
  }
}
